<template>
<div class="animated fadeIn">

  <b-card no-body>
    <b-card-body>
    <p><strong>Date Range: {{ reservation.arrival_date }} / {{ reservation.departure_date }}</strong></p>
    <p><strong>Total Bhent (Rupees): {{ _.round(totalAmount) }}</strong></p>
    </b-card-body>
  </b-card>

  <b-card no-body>
    <b-card-body>
      <v-client-table :data="rooms" :columns="columns" :options="options" :theme="theme">
        <span slot="has_toilet" slot-scope="data">{{data.row.has_toilet ? 'Yes' : 'No'}}</span>
        <span slot="has_ac" slot-scope="data">{{data.row.has_ac ? 'Yes' : 'No'}}</span>
      </v-client-table>
    </b-card-body>
  </b-card>

  <b-card no-body>
    <b-card-body>
      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="Bhent by Cash" active>

            <b-form-group label="Total Cash" label-for="totalCash">
              <b-input-group>
                <b-form-input id="totalCash" type="number" v-model="totalCash" placeholder="Total Cash"
                  autofocus />
                <b-input-group-append>
                  <calculate-popover target="btnTotalCash" @ok="calculateTotalCash" />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-form-group label="Aditional Bhent" label-for="donation">
              <b-input-group>
                <b-form-input id="donation" type="number" v-model="donation" placeholder="Aditional Bhent"/>
              </b-input-group>
            </b-form-group>

            <b-form-group label="Change" label-for="change">
              <b-input-group>
                <b-form-input id="change" type="number" v-model="change" disabled />
              </b-input-group>
            </b-form-group>

            <b-button @click="submitCash" variant="primary" :disabled="!canSubmit">
              Submit
            </b-button>

          </b-tab>
          <b-tab title="Bhent by Card"><p>Not implemented yet</p></b-tab>
        </b-tabs>
      </div>
    </b-card-body>
  </b-card>

</div>
</template>

<script>

import {
  mapState,
} from 'vuex'
import CalculatePopover from './CalculatePopover'
import moment from 'moment'

export default {
  name: "Payment",
  props: {
    reservation: Object
  },
  components: {
    CalculatePopover
  },
  watch: {
    totalCash(value) {
      let donation = isNaN(parseFloat(this.donation)) ? 0 : parseFloat(this.donation)
      let totalCash = isNaN(parseFloat(value)) ? 0 : parseFloat(value)
      let total = this.totalAmount + donation
      this.change = totalCash >= total ? totalCash - total : null
    },
    donation(value) {
      let donation = isNaN(parseFloat(value)) ? 0 : parseFloat(value)
      let totalCash = isNaN(parseFloat(this.totalCash)) ? 0 : parseFloat(this.totalCash)
      let total = this.totalAmount + donation
      this.change = totalCash >= total ? totalCash - total : null
    }
  },
  computed: {
    stayDays() {
    let start = moment(this.reservation.arrival_date);
    let end = moment(this.reservation.departure_date);
    let duration = moment.duration(end.diff(start));
    let days = duration.asDays();
    return Math.round(days);
  },
    canSubmit() {
      let donation = isNaN(parseFloat(this.donation)) ? 0 : parseFloat(this.donation)
      let totalCash = isNaN(parseFloat(this.totalCash)) ? 0 : parseFloat(this.totalCash)
      let total = this.totalAmount + donation
      return totalCash >= total
    },
    totalAmount() {
      let total = 0;
      let totalDays = this.stayDays;
      _.each(this.rooms, (room) => {
        total += parseFloat(room.price * totalDays)
      })
      // total = _.round(total, 2).toFixed(2)
      return total
    },
    ...mapState({
      rooms: state => state.reservations.selectedRooms
    })
  },
  data() {
    return {
      totalCash: 0,
      donation: 0,
      change: null,
      columns: [
        'floor.building.name',
        'floor.floor_number',
        'room_number',
        'floor.building.price',
        'number_of_beds',
        'max_occupiers',
        'toilet_type',
        'has_ac',
      ],
      options: {
        headings: {
          'floor.building.name': 'Building',
          'floor.floor_number': 'Floor',
          room_number: 'Room Number',
          number_of_beds: "Beds",
          max_occupiers: "Max Occupiers",
          toilet_type: "Toilet",
          has_ac: "AC",
          'floor.building.price': 'Bhent/Day'
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
    }
  },
  methods: {


    calculateTotalCash(value) {
      this.totalCash = value
    },
    submitCash() {
      let params = {
        id: this.reservation.id,
        payment_amount: this.totalCash,
        donation_amount: this.donation,
        payment_type: 'CASH'
      }

      this.$store.dispatch('reservations/setStatusPaid', params)
      .then(() => {
        this.$emit('success')
        this.showSuccessMsg()
      })
      .catch((error) => {
        if (error.response.status == 400) {
          this.showErrorMsg({
            message: error.response.data.message
          })
        } else {
          this.showErrorMsg()
        }
      })

    }
  },
  created() {
    this.$store.dispatch('reservations/getSelectedRooms', {id: this.reservation.id})
  }
}
</script>
